(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diwali"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('diwali-edit')) {
    customElements.define('diwali-edit', class extends HTMLElement {
      connectedCallback() { this.boot = requestAnimationFrame(() => this.init()); }
      init() {
        if (this.controller || !this.isConnected) return;
        this.track = this.querySelector('[data-track]');
        this.items = [...this.querySelectorAll('[data-item]')];
        if (!this.track || !this.items.length) return;
        this.controller = new AbortController();
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.toggle = this.querySelector('[data-toggle]');
        this.counter = this.querySelector('[data-counter]');
        this.progress = this.querySelector('[data-progress]');
        this.controls = this.querySelector('[data-controls]');
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.enabled = this.dataset.autoplay === 'true' && this.dataset.editor !== 'true';
        this.paused = false;
        this.hovered = matchMedia('(hover:hover)').matches && this.matches(':hover');
        this.visible = false;
        this.index = 0;
        this.points = [0];
        this.delay = Math.max(3000, Number(this.dataset.delay) || 4500);
        this.on(this.prev, 'click', () => this.move(-1, true));
        this.on(this.next, 'click', () => this.move(1, true));
        this.on(this.toggle, 'click', () => { this.paused = !this.paused; this.playback(); });
        this.on(this, 'pointerenter', e => { if (e.pointerType === 'mouse') { this.hovered = true; this.schedule(); } });
        this.on(this, 'pointerleave', e => { if (e.pointerType === 'mouse') { this.hovered = false; this.schedule(); } });
        this.on(this, 'focusin', e => { if (!this.toggle.contains(e.target)) this.pause(); });
        this.on(this, 'focusout', () => { queueMicrotask(() => this.schedule()); });
        this.on(this.track, 'pointerdown', () => this.pause(), { passive:true });
        this.on(this.track, 'wheel', () => this.pause(), { passive:true });
        this.on(this.track, 'keydown', e => {
          if (e.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
          e.preventDefault();
          this.pause();
          if (e.key === 'Home') this.go(0);
          else if (e.key === 'End') this.go(this.items.length - 1);
          else this.move((e.key === 'ArrowRight' ? 1 : -1) * (this.rtl ? -1 : 1), true);
        });
        this.on(this.track, 'scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.paint());
          clearTimeout(this.settle);
          this.settle = setTimeout(() => { this.announce(); this.schedule(); }, 160);
        }, { passive:true });
        this.on(document, 'visibilitychange', () => this.schedule());
        this.on(this.motion, 'change', () => this.playback());
        this.resize = new ResizeObserver(() => this.measure());
        this.resize.observe(this.track);
        this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
        this.observer.observe(this);
        this.classList.add('is-ready');
        this.measure();
      }
      on(target, event, callback, options = {}) {
        target.addEventListener(event, callback, { ...options, signal:this.controller.signal });
      }
      measure() {
        if (!this.track.clientWidth) { clearTimeout(this.timer); return; }
        this.rtl = getComputedStyle(this.track).direction === 'rtl';
        const first = this.items[0].getBoundingClientRect();
        const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        this.points = this.items.map(item => {
          const box = item.getBoundingClientRect();
          return Math.min(max, Math.max(0, this.rtl ? first.right - box.right : box.left - first.left));
        });
        this.controls.hidden = this.items.length < 2 || max < 2;
        this.paint();
        this.announce();
        this.playback();
      }
      paint() {
        const position = Math.abs(this.track.scrollLeft);
        this.index = this.points.reduce((nearest, point, i) => Math.abs(point - position) < Math.abs(this.points[nearest] - position) ? i : nearest, 0);
        this.items.forEach((item, i) => item.classList.toggle('is-active', i === this.index));
        this.prev.setAttribute('aria-disabled', String(this.index === 0));
        this.next.setAttribute('aria-disabled', String(this.index === this.items.length - 1));
        this.progress.style.setProperty('--dfe-progress', (this.index + 1) / this.items.length);
      }
      announce() {
        const text = this.dataset.status.replace('[current]', String(this.index + 1).padStart(2, '0'));
        if (this.counter.textContent !== text) this.counter.textContent = text;
      }
      go(index) {
        const target = this.points[index];
        if (target === undefined) return;
        this.track.scrollTo({ left:this.rtl ? -target : target, behavior:this.motion.matches ? 'auto' : 'smooth' });
      }
      move(direction, manual = false) {
        if (manual) this.pause();
        let target = this.index + direction;
        if (!manual && target >= this.items.length) target = 0;
        if (target >= 0 && target < this.items.length) this.go(target);
      }
      pause() { this.paused = true; this.playback(); }
      playback() {
        const allowed = this.enabled && !this.motion.matches && this.items.length > 1;
        const playing = allowed && !this.paused;
        this.toggle.hidden = !allowed;
        this.toggle.dataset.playing = String(playing);
        this.toggle.setAttribute('aria-label', playing ? this.dataset.pause : this.dataset.play);
        this.counter.setAttribute('aria-live', playing ? 'off' : 'polite');
        this.schedule();
      }
      schedule() {
        clearTimeout(this.timer);
        const focused = this.contains(document.activeElement) && !this.toggle.contains(document.activeElement);
        if (!this.isConnected || !this.enabled || this.paused || this.hovered || focused || !this.visible || document.hidden || this.motion.matches || this.items.length < 2 || !this.track.clientWidth) return;
        this.timer = setTimeout(() => { this.move(1); this.schedule(); }, this.delay);
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.boot);
        cancelAnimationFrame(this.frame);
        clearTimeout(this.timer);
        clearTimeout(this.settle);
        this.controller?.abort();
        this.resize?.disconnect();
        this.observer?.disconnect();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
